import BaseModel from '../model/BaseModel';

export default class Ticket extends BaseModel {

    constructor(data) {
        super();
        this.Id = data.Id;
        this.Description = data.Description;
        this.IsTicketPackage = data.IsTicketPackage;
        this.PackageId = data.PackageId;
        this.PackageTicket = data.PackageTicket;
        this.PriceCents = data.PriceCents || 0;
        this.LoyaltyRecognitionSequence = data.LoyaltyRecognitionSequence;
        this.LoyaltyRecognitionId = data.LoyaltyRecognitionId ;
        this.SeatData = data.SeatData;
        this.SeatNumber = data.SeatNumber;
        this.SeatRowId = data.SeatRowId;
        this.SeatNumberCombined = data.SeatNumberCombined;
        this.SeatId = Number(data.SeatId);
        this.TicketTypeCode = data.TicketTypeCode;
        this.Position = data.Position;
        this.ThirdPartyMemberScheme = data.ThirdPartyMemberScheme || null;
        this.Barcode = data.Barcode || null;
        this._status = {}

    }

    get status() {
        return this._status;
    }

    set status(value) {
        this._status = value;
    }

    get price() {
        return this.PriceCents / 100;
    }

    get priceString() {
        var priceFormatted = this.price.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        return `R${priceFormatted}`
    }
}


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/Ticket.js